(function CaptchaV3($, Adzuki)
{
	"use strict";

	const CaptchaV3 = {};
	const failureMessage = 'Unable to verify that you are human. Please contact your agent or Cruise Planners support for assistance.';

	function _showError($button, message) {
		Adzuki.StatusMessage('error', message || failureMessage);
		$button.removeClass('disabled');
	}

	CaptchaV3.init = function _init() {
		const captchaEl = $('.g-recaptcha');

		// bail if no captcha element appears on the page
		if (captchaEl.length === 0) {
			return;
		}

		captchaEl.on('click', function _captchaSubmit(e) {
			const siteKey = window.myGcapSiteKey;
			const $form   = $(this).closest('form');
			const $button = $(this);

			e.preventDefault();

			if (!siteKey) {
				_showError($button, failureMessage);
				return;
			}

			grecaptcha.ready(function _captchaReady() {
				const execData = {
					action: 'submit',
				};

				grecaptcha.execute(siteKey, execData)
				.then(function _processToken(token) {
					const url = Adzuki.base_uri + '/CaptchaThree/checkCaptcha/' + token;

					Adzuki.Ajax.get(url).then(function _success(response) {
						if (response.success) {
							$form.submit();
						} else {
							_showError($button, response.message || failureMessage);
						}
					}).fail(function _ajaxFail() {
						_showError($button, failureMessage);
					});
				}).catch(function _executeReject() {
					_showError($button, failureMessage);
				});
			});
		});
	};

	Adzuki.CaptchaV3 = CaptchaV3;
}(jQuery, window.Adzuki || {}));
